import { runWithAdal } from "react-adal/lib/react-adal";
import { authContext } from "./adalConfig";
import './assets/index.css';

runWithAdal(
  authContext,
  () => { require('./indexApp') },
  false
);